import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { ST_PROTOCOL_ITEMS } from './stProtocolConstants';

const StProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="ST"
            title="ST JOB DESCRIPTION"
            items={ST_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default StProtocol;
